import { ComplaintCategories } from "apollo/data";
import { SearchSelectInput } from "components/core";
import _ from "lodash";
import { FC } from "react";
interface ComplaintCategoryPickerProps {
  id: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  labelHidden?: boolean;
  values: any;
  errors?: any;
  touched?: any;
  setFieldValue: any;
  setFieldTouched?: any;
  setFieldError?: any;
  rawId?: boolean;
  isNonServicePoint?: boolean;
}

const ComplaintCategoryPicker: FC<ComplaintCategoryPickerProps> = ({
  id,
  label,
  rawId,
  isNonServicePoint,
  ...form
}) => {
  return (
    <SearchSelectInput
      id={id ?? "category"}
      label={label ?? ""}
      placeholder="Select Complaint Category"
      options={ComplaintCategories?.filter(
        (complaint) =>
          ["General", "Operations"].includes(complaint.name) ||
          !isNonServicePoint,
      )?.map((complaint) => ({
        label: {
          title: _.startCase(complaint.name) as string,
        },
        value: rawId ? complaint?.name : complaint,
      }))}
      {...form}
      disabled={form.disabled}
    />
  );
};

export default ComplaintCategoryPicker;
